import { catchError as rxjscatchError, map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { GoodsType, ReceptionControl } from './../models/reception-control';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ReceptionControlService {
  constructor(private http: HttpClient) {}

  getAll(foodSafetyId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/foodsafety/receptioncontrol/' + foodSafetyId
      ).pipe(rxjsmap((result: any) => result));
  }

  /**
   * Get paginated reception control list
   * @param foodSafetyId Food Safety ID (required) - defines the scope of access
   * @param filter Pagination and filter criteria
   * @returns Observable with paginated response
   */
  getPagedReceptionControls(foodSafetyId: number, filter: any) {
    return this.http
      .post(
        `${environment.BASE_URL}/foodsafety/receptioncontrol/${foodSafetyId}/paged`,
        filter
      ).pipe(rxjsmap((result: any) => result));
  }

  addReceptionControl(receptionControl: ReceptionControl) {
    return this.http
      .post(
        environment.BASE_URL + '/foodsafety/reception-control',
        receptionControl
      ).pipe(rxjsmap(result => result));
  }

  getById(foodSafetyId: number, receptionId: number) {
    return this.http
      .get(
        `${environment.BASE_URL}/foodsafety/receptioncontrol/${foodSafetyId}/${receptionId}`
      ).pipe(rxjsmap((result: any) => result));
  }

  getGoodsTypeByBusiness(businessId: number) {
    return this.http
      .get(environment.BASE_URL + '/foodsafety/goodstypes/' + businessId).pipe(rxjsmap((result: any) => result));
  }

  deleteGoodsType(id: number) {
    return this.http
      .put(environment.BASE_URL + '/foodsafety/goodstype/' + id, {}).pipe(rxjsmap(result => result));
  }

  updateGoodsType(existingGoodsType: GoodsType) {
    return this.http
      .put(environment.BASE_URL + '/foodsafety/goodstype/', existingGoodsType).pipe(rxjsmap(result => result));
  }

  createGoodsType(newGoodsType: GoodsType) {
    return this.http
      .post(`${environment.BASE_URL}/foodsafety/goodstype`, newGoodsType).pipe(rxjsmap(result => result));
  }

  deleteReception(ids: number[]) {
    return this.http
      .put(environment.BASE_URL + '/foodsafety/receptioncontrol', ids).pipe(rxjsmap(result => result)).pipe(rxjscatchError(this.handleError));
  }

  getNextReceptionNo() {
    return this.http
      .get(
        `${environment.BASE_URL}/foodsafety/next-reception/${BaseServices.BusinessId}`
      ).pipe(rxjsmap(result => result));
  }

  getReceptionLog(receptionId: number) {
    return this.http
      .get(`${environment.BASE_URL}/foodsafety/receptionlog/${receptionId}`).pipe(rxjsmap(result => result));
  }

  getReceptionControlDocument(featureId: number, receptionControlId: number) {
    return this.http.get(
      `${environment.BASE_URL}/foodsafety/getreceptiondocument/${featureId}/${receptionControlId}`
    );
  }

  deleteReceptionControlDocument(
    featureId: number,
    receptionControlId: number,
    id: number
  ) {
    return this.http
      .delete(
        `${environment.BASE_URL}/foodsafety/deletereceptiondocument/${featureId}/${receptionControlId}/${id}`
      ).pipe(rxjsmap((response: any) => {
        if (response.status === 200) {
          let data = response.data || [];
          data.forEach(d => {
            d.CreatedOn = new Date(d.CreatedOn);
            d.ModifiedOn = new Date(d.ModifiedOn);
          });
          response.data = data;
          return response;
        } else {
          return response || {};
        }
      }));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}
